module.exports = __webpack_public_path__ + "img/categorie-nos-points-de-vente-famille-boutrais-small.9e794d07.jpg";